import { useTranslate } from '@tolgee/react';
import React, { FC, useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

interface CreateFolderModalProps {
  show: boolean;
  onClose: () => void;
  onCreate: (data: {
    name: string;
    editUuid?: string;
    folderUuid?: string;
  }) => void;
  action: 'edit' | 'create';
  name?: string;
}

const CreateFolderModal: FC<CreateFolderModalProps> = ({
  show,
  onClose,
  onCreate,
  action,
  name = ''
}) => {
  const { t } = useTranslate();

  const [folderName, setFolderName] = useState('');

  useEffect(() => {
    setFolderName(name);
  }, [name]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmedName = folderName.trim();
    if (trimmedName) {
      onCreate({ name: trimmedName });
      setFolderName('');
      onClose();
    }
  };

  const handleClose = () => {
    setFolderName('');
    onClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {action === 'create'
            ? t('lomavisCreator.textBlock.createFolder')
            : t('lomavisCreator.textBlock.editFolder')}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group>
            <Form.Label>{t('lomavisCreator.textBlock.folderName')}</Form.Label>
            <Form.Control
              type="text"
              value={folderName}
              onChange={(e) => setFolderName(e.target.value)}
              placeholder=""
              maxLength={60}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t('lomavisCreator.textBlock.cancel')}
          </Button>
          <Button variant="primary" type="submit">
            {action === 'create'
              ? t('lomavisCreator.textBlock.create')
              : t('lomavisCreator.textBlock.edit')}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CreateFolderModal;
